import React, { useEffect, useState } from "react";
import { ParseDate } from "../../../../../../../src/helpers/Parsers";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

import styles from "./TemplateTagsTableItemMobile.module.scss";
import { OrderService } from "services/OrderService";

const mapping = {
  BOX: i18n.t("box").toUpperCase(),
  PALLET: i18n.t("pallet").toUpperCase(),
  PRODUCT: i18n.t("product").toUpperCase()
};

export const TemplateTagsItemMobile = ({
  itemTag,
  handleClick,
}) => {

  const height_width = itemTag.height ? `${i18n.t("height")} ${itemTag.height} mm | ${i18n.t("width")} ${itemTag.width} mm` : '';

  const prueba = (e) => {
    handleClick(e);
  };

  const [destination, setDestination] = useState("")

  useEffect(()=> {
    if(itemTag.order){
      getDetination()
    }
  }, [])

  const getDetination = () => {
    OrderService.relocationOrder(itemTag.order.id).then((order) => {
      setDestination(order.destination.name);
    });

  }

  return (
    <div
      className={`${styles["template-tags-table-item-mobile-container"]} ${itemTag.order ? styles["destination"] :""}`}
      data-automation-id="template-tags-table-item"
      data-itemtag-id={itemTag.id}
      onClick={prueba}
    >
      <div className={styles["template-tags-table-item-mobile-name"]}>
      {capitalize(i18n.t("name"))}: {itemTag.name}
      </div>

      <div className={styles["template-tags-table-item-mobile-description"]}>
      {capitalize(i18n.t("description"))}: {itemTag.description}
      </div>

      <div className={styles["template-tags-table-item-mobile-date"]}>
      {i18n.t("date")}: {ParseDate(itemTag.created_at)}
      </div>

      <div className={styles["template-tags-table-item-mobile-type"]}>
      {capitalize(i18n.t("type"))}: <span className={styles["tag-pill"]}>{ mapping[itemTag.type] }</span>
      </div>

      <div className={styles["template-tags-table-item-mobile-dimensions"]}>
      {i18n.t("dimensions")}: {height_width}
      </div>

      <div className={styles["template-tags-table-item-mobile-memories"]}>
      {i18n.t("memories")}: {itemTag.mem_epc + "GB | " + itemTag.mem_user + "GB"}
      </div>

    </div>
  );
};

export default TemplateTagsItemMobile;
